import { KeyValue } from '@app/core/components/KeyValue';
import { MinimumStationsGroup, StationGroupAccessType } from '@app/core/types/stations';
import { StationLabel } from '@app/modules/admin/screens/stations/list/StationLabel';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { stationGroupsMessages } from '../station-groups-messages';

interface Props {
  group: MinimumStationsGroup;
}

/**
 * Read-only station group details: name, slug, access type, and member stations.
 */
export function StationGroupInfo({ group }: Props) {
  const stations = group.stations ?? [];

  return (
    <Box>
      <KeyValue label={<FormattedMessage id="common.text.name" defaultMessage="Nombre" />}>
        {group.name}
      </KeyValue>
      <KeyValue label={<FormattedMessage {...stationGroupsMessages.slugLabel} />}>
        {group.slug}
      </KeyValue>
      {group.accessType != null && (
        <KeyValue label={<FormattedMessage {...stationGroupsMessages.accessTypeLabel} />}>
          {group.accessType === StationGroupAccessType.OWNED ? (
            <FormattedMessage {...stationGroupsMessages.accessTypeOwned} />
          ) : (
            <FormattedMessage {...stationGroupsMessages.accessTypeShared} />
          )}
        </KeyValue>
      )}
      <KeyValue label={<FormattedMessage {...stationGroupsMessages.stationsLabel} />}>
        {stations.length === 0 ? (
          <FormattedMessage {...stationGroupsMessages.noStations} />
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {stations.map((station) => (
              <Box
                key={station.id}
                component={Link}
                to={`/admin/stations/${station.slug}`}
                sx={{
                  textDecoration: 'none',
                  color: 'inherit',
                  '&:hover': { color: 'primary.main' },
                }}
              >
                <StationLabel station={station} indicatorsDisplay={false} />
              </Box>
            ))}
          </Box>
        )}
      </KeyValue>
    </Box>
  );
}
